import { FAVORITES_TARGET } from '../contexts/favorites-context';

const DURATION = {
  EXTRA_SHORT: 1000,
  SHORT: 1300,
  MEDIUM: 1700,
  LONG: 2200,
}

const common = {
  position: 'top',
  duration: DURATION.LONG,
  isClosable: true,
}


/*******************MAIN TOASTS*******************/
export const toastSuccess = {
  ...common,
  status: "success"
} 

export const toastError = {
  ...common,
  status:"error"
} 

export const toastWarning = {
  ...common,
  status: "warning"
}

/*******************MAIN TOASTS*******************/


/*******************FAVORITES TOASTS*******************/
const favorites = {
  isClosable: true, 
  variant: "subtle",
  duration: DURATION.SHORT,
}

export const toastRemoveFavoriteFromDrawer = (toast, item, target) => {
  toast.closeAll();
  toast({
    title: `Removed from favorites`,
    status: "error",
    position: "top-right",    
    description: target === FAVORITES_TARGET.LAUNCHES ? item.mission_name : item.name,
    ...favorites
  })
}

export const toastToggleFavorite = (toast, item, target, isFavorite) => {
  toast.closeAll();
  toast({
    title: !isFavorite ? "Added to favorites" : `Removed from favorites`,
    status: !isFavorite ? "success" : "error",
    position: "top",    
    description: target === FAVORITES_TARGET.LAUNCHES ? item.mission_name : item.name,
    ...favorites
  })
}

/*******************FAVORITES TOASTS*******************/


/*******************OTHER TOASTS*******************/


/*******************OTHER TOASTS*******************/